import {SearchProduct} from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import {Link} from '@/i18n/routing';
import AddToCartButton from '../design-system/AddToCartButton';
import {Price} from '../design-system/Price';
import ProductItemMobile from './ProductItemMobile';
import ProductItemThumb from './ProductItemThumb';

interface IProps {
  product: SearchProduct;
  isShowOnly?: boolean;
  button?: any;
  hidePrice?: boolean;
}

const ProductItem = ({
  product,
  isShowOnly,
  button,
  hidePrice = false,
}: IProps) => {
  return (
    <>
      <div className="h-full product-item product-card">
          <div className="h-full flex flex-col justify-between">
            <div>
              <div>
                <ProductItemThumb
                  product={product}
                  wishListButton={!isShowOnly}
                  isShowOnly={isShowOnly}
                />
              </div>
              <div>
                <h3 className="text-left font-medium mb-2">
                  {isShowOnly ? (
                    <span>{product.name}</span>
                  ) : (
                    <Link
                      className="duration-300 text-greyscale-gray-darker leading-normal no-underline hover:text-primary"
                      href={{
                        pathname: '/shop/[id]',
                        params: { id: product.slug! },
                      }}
                    >
                      {product.name}
                    </Link>
                  )}
                </h3>
                <h4
                  className="text-left capitalize leading-3 text-greyscale-gray-dark font-normal m-0 text-sm">
                  {product.producer}
                </h4>
              </div>
            </div>
            <div className="flex items-center justify-between mt-3 gap-2">
              {!hidePrice && (
                <h4 className="m-0 text-xl text-greyscale-gray-dark font-normal text-left">
                  <Price
                    price={product.price}
                    discountedPrice={product.discountedPrice}
                  />
                </h4>
              )}

              {button ? (
                <>{button} </>
              ) : (
                <AddToCartButton product={product} />
              )}
            </div>
          </div>
        </div>
      {/** Mobile layout */}
      <div className="hidden">
        <ProductItemMobile
          key={product.id}
          product={product}
          isShowOnly={isShowOnly}
          button={button}
          hidePrice={hidePrice}
        />
      </div>
    </>
  );
};

export default ProductItem;
